import { render } from "./ClienteDetail.vue?vue&type=template&id=39000a3e&scoped=true"
import script from "./ClienteDetail.vue?vue&type=script&lang=js"
export * from "./ClienteDetail.vue?vue&type=script&lang=js"

import "./ClienteDetail.vue?vue&type=style&index=0&id=39000a3e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39000a3e"]])

export default __exports__